import React from 'react';
import './EducationOneServices.scss'; // Include your SCSS for styling

function ERPSection() {
  return (
    <div className="erp-section">
      <div className="container">
     
       

      {/* Main Section */}
      <main className="erp-main">
        <h1>Why We're Awesome?</h1>
        <p>
          With more than 16 years of experience in this industry, we know what it’s like to be at every stage of a growing business.
        </p>

        {/* Cards Section */}
        <div className="erp-cards">
          <div className="erp-card">
            <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQtEB4g3bOJIbpirmLtrOWAgXr_CjRRlUbkUA&s" alt="User Interface" />
            <div className="card-content">
              <h3>Simple Straight Forward User Interface Ect</h3>
              
            </div>
          </div>
          <div className="erp-card">
            <img src="https://tse2.mm.bing.net/th?id=OIP.JhcVttJ2_t-ecl4Wom-oWwHaFp&pid=Api&P=0&h=220" alt="Developer Platform" />
            <div className="card-content">
              <h3>Easy Access</h3>
            </div>
          </div>
          <div className="erp-card">
            <img src="https://tse2.mm.bing.net/th?id=OIP.JhcVttJ2_t-ecl4Wom-oWwHaFp&pid=Api&P=0&h=220" alt="Migration Wizard" />
            <div className="card-content">
              <h3>Migration Wizard To Data From Spreadly</h3>
            </div>
          </div>
          <div className="erp-card">
            <img src="https://content.jdmagicbox.com/v2/comp/bangalore/i3/080pxx80.xx80.140421160527.d1i3/catalog/tcl-customer-care--bangalore-am8um.jpg" alt="Customer Support" />
            <div className="card-content">
              <h3>Customer Support with High Satisfaction</h3>
            </div>
          </div>
          <div className="erp-card">
            <img src="https://simplycontact.com/wp-content/uploads/2023/03/Customer-Support-Outsourcing-Department.png.webp" alt="Customer Support" />
            <div className="card-content">
              <h3>Customer Support with High Satisfaction</h3>
            </div>
          </div>
          <div className="erp-card">
            <img src="https://d1eipm3vz40hy0.cloudfront.net/images/AMER/CustomerSupportBlogHero.png" alt="Customer Support" />
            <div className="card-content">
              <h3>Customer Support with High Satisfaction</h3>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
  );
}

export default ERPSection;
